import React, {ReactNode} from 'react';

interface FeatureCard {
    title: string;
    subtitle: string;
    icon: ReactNode;
}

const iconProps = {
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
};

const FEATURES: FeatureCard[] = [
    {
        title: 'ישירות מהמקור',
        subtitle: 'בלי מתווכים',
        icon: (
            <svg {...iconProps}>
                <circle cx="12" cy="5" r="2.4"/>
                <circle cx="5" cy="19" r="2.4"/>
                <circle cx="19" cy="19" r="2.4"/>
                <path d="M12 7.4v2.6M11 11l-4.5 6M13 11l4.5 6"/>
            </svg>
        ),
    },
    {
        title: 'מתחייבים לתוכן',
        subtitle: 'כתיבה מקצועית',
        icon: (
            <svg {...iconProps}>
                <path d="M6 3h8l4 4v14H6z"/>
                <path d="M14 3v4h4"/>
                <path d="M9 12h6M9 16h4"/>
            </svg>
        ),
    },
    {
        title: 'אתרים עם אוטוריטה',
        subtitle: 'מדיה מובילה',
        icon: (
            <svg {...iconProps}>
                <path
                    d="M12 2.5l2.3 1.5 2.8-.1.9 2.6 2.3 1.6-.9 2.7.9 2.7-2.3 1.6-.9 2.6-2.8-.1L12 21.5l-2.3-1.5-2.8.1-.9-2.6-2.3-1.6.9-2.7-.9-2.7 2.3-1.6.9-2.6 2.8.1z"/>
                <path d="M9 12l2 2 4-4.5"/>
            </svg>
        ),
    },
    {
        title: 'מומחי SEO לצידכם',
        subtitle: 'ליווי אנושי',
        icon: (
            <svg {...iconProps}>
                <path d="M4 13v-1.5a8 8 0 0 1 16 0V13"/>
                <rect height="6" rx="1.4" width="4" x="3" y="13"/>
                <rect height="6" rx="1.4" width="4" x="17" y="13"/>
                <path d="M20 19v.4a3 3 0 0 1-3 3h-3"/>
            </svg>
        ),
    },
];

const FeatureGrid: React.FC = () => (
    <div className="lnk-hero__features">
        {FEATURES.map(feature => (
            <div className="lnk-hero__feature" key={feature.title}>
                <span className="lnk-hero__feature-icon" aria-hidden="true">{feature.icon}</span>
                <div className="lnk-hero__feature-title">{feature.title}</div>
                <div className="lnk-hero__feature-sub">{feature.subtitle}</div>
            </div>
        ))}
    </div>
);

export default FeatureGrid;
